import { useTranslation } from 'react-i18next'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/shadcn/tabs'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { AnalysisFileType } from '@/api/model/analysisFileType'
import { InvoicesTab } from './tabs/InvoicesTab'
import { AnalysisFilesTab } from './tabs/AnalysisFilesTab'

const ANALYSIS_TAB_VALUES = [
  AnalysisFileType.NewEmployeesAnalysisFile,
  AnalysisFileType.BoughtVouchersAnalysisFile,
  AnalysisFileType.UpcomingBonusRewardsAnalysisFile,
  AnalysisFileType.DirectPayoutAnalysisFile,
  AnalysisFileType.CompanyPensionAnalysisFile,
]

export default function BillingPage() {
  const { t } = useTranslation('billing')

  return (
    <PageLayout>
      <PageHeader title={t('header.title')} />

      <Tabs defaultValue="invoices" className="flex-1 min-h-0 min-w-0">
        <TabsList className="flex-wrap h-auto! gap-1 [&_[data-slot=tabs-trigger]]:h-auto">

          <TabsTrigger value="invoices">{t('tabs.invoices')}</TabsTrigger>
          {ANALYSIS_TAB_VALUES.map((value) => (
            <TabsTrigger key={value} value={value}>{t(`tabs.analysisFileType.${value}`)}</TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="invoices" className="mt-4 min-h-0 min-w-0 flex flex-col">
          <InvoicesTab />
        </TabsContent>

        {ANALYSIS_TAB_VALUES.map((value) => (
          <TabsContent key={value} value={value} className="mt-4 min-h-0 min-w-0 flex flex-col">
            <AnalysisFilesTab fileType={value} />
          </TabsContent>
        ))}
      </Tabs>
    </PageLayout>
  )
}
